module.exports = __webpack_public_path__ + "img/monthly-icon.f374a416.svg";